const Customers = () => import("Core/companies/customers/views/Customers");
const CustomerProfile = () => import("Core/companies/customers/views/Profile");

export default {
    children: [
        {
            path: "customers",
            name: "customers",
            component: Customers,
            meta: {
                requiresAuth: true,
                title: "lang.customer",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["companies.read"],
            },
        },
        /*{
            path: "customer/:id?",
            name: "customers_profile",
            component: CustomerProfile,
            meta: {
                requiresAuth: true,
                title: "lang.customer",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["companies.read"],
            },
        },*/
        {
            path: "customers/profile/:id(\\d+)?/:tab?",
            name: "customers_profile",
            component: CustomerProfile,
            meta: {
                requiresAuth: true,
                title: "lang.customer",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["companies.read"],
            },
        },
    ],
};
